import type { ReactNode } from 'react';

import ProsopiteErrorNotifier from '@/components/development/prosopite-error-notifier';
import InertiaMetaTags from '@/components/inertia-meta-tags';
import {
  CustomFooterScripts,
  CustomHeaderScripts,
} from '@/components/page-sections/custom-scripts';
import { CookieBanner } from '@/components/public/cookie-banner';
import { GoogleAnalyticsTracking } from '@/components/public/google-analytics-tracking';
import { AwsWafIntegrationScript } from '@/components/shared/aws-waf-integration-script';
import { Toaster } from '@/components/ui/toast';

export default function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <InertiaMetaTags />
      <AwsWafIntegrationScript />
      <GoogleAnalyticsTracking />
      <CustomHeaderScripts />
      <div id="public-layout">
        <Toaster />
        <ProsopiteErrorNotifier />
        {children}
        <CookieBanner />
      </div>
      <CustomFooterScripts />
    </>
  );
}
